import { createApi } from "@reduxjs/toolkit/query/react";
import { apiUrls } from "constants/apiUrls";
import { baseQueryWithReAuth } from "utils/baseQueryWithReAuth";
import { getResolvedUrl } from "utils/getResolvedUrl";
import {
    GetActiveSubscriptionRes,
} from "./types";

export const subscriptionListApiSlice = createApi({
    reducerPath: "subscriptionListApi",
    baseQuery: baseQueryWithReAuth,
    endpoints(builder) {
        return {
            getSubscriptionList: builder.query<GetActiveSubscriptionRes, any>({
                query: () => ({
                    url: apiUrls.subscriptionList,
                    method: "GET",
                }),
            }),
            deleteActiveSubscription: builder.mutation({
                 query: ({ user_id, method = "POST", data }) => ({
                      method,
                      body: data,
                      url: getResolvedUrl(apiUrls.deleteSubscription, { user_id }),
                 }),
            }),
            renewSubscription: builder.mutation({
                query: (user_id) => ({
                    url: `${apiUrls.billing.replace("{user_id}", user_id)}`,
                    method: "GET",
                }),
            }),
        };
    },
});

export const {
    useGetSubscriptionListQuery,
    useDeleteActiveSubscriptionMutation,
    useRenewSubscriptionMutation
} = subscriptionListApiSlice;
